export type FormFields = {
    userId: string,
    password: string,
    retypePwd: string,
    firstName: string,
    lastName: string,
    phone: string,
    taxId: string,
    termsAndConditions: boolean,
    emailAddress: string,
    privacyStatement: boolean
}

export const userIdErrorsModel = {
    userIdLengthErrors: {
        'error': false,
        'success': false,
        'default': true
    },
    oneLetteError: {
        'error': false,
        'success': false,
        'default': true
    },
    specialCharacterError: {
        'error': false,
        'success': false,
        'default': true
    }

}

export const validateUserId = (values: Pick<FormFields, 'userId'>): any => {
    const userIdErrorsObj = Object.assign(userIdErrorsModel)
    if (values.userId) {
        if (values.userId.length < 5 || values.userId.length > 20) {
            userIdErrorsObj.userIdLengthErrors.error = true
            userIdErrorsObj.userIdLengthErrors.success = false;
            userIdErrorsObj.userIdLengthErrors.default = false;
        }
        else {
            userIdErrorsObj.userIdLengthErrors.error = false;
            userIdErrorsObj.userIdLengthErrors.success = true;
            userIdErrorsObj.userIdLengthErrors.default = false;
        }

        if (!/(?=[A-Za-z])/g.test(values.userId) || !values.userId) {
            userIdErrorsObj.oneLetteError.error = true
            userIdErrorsObj.oneLetteError.success = false;
            userIdErrorsObj.oneLetteError.default = false;
        }
        else {
            userIdErrorsObj.oneLetteError.error = false
            userIdErrorsObj.oneLetteError.success = true;
            userIdErrorsObj.oneLetteError.default = false;
        }

        if (/[^\dA-Za-z]/g.test(values.userId)) {
            userIdErrorsObj.specialCharacterError.error = true
            userIdErrorsObj.specialCharacterError.success = false;
            userIdErrorsObj.specialCharacterError.default = false;
        }
        else {
            userIdErrorsObj.specialCharacterError.error = false
            userIdErrorsObj.specialCharacterError.success = true;
            userIdErrorsObj.specialCharacterError.default = false;
        }
    }

    return userIdErrorsObj && values.userId ? userIdErrorsObj : userIdErrorsModel;
};

export const validateNewUserForm = (newUser: any) => {
    const invalid = [];
    if (newUser.firstName.length === 0 ) {
        invalid.push('firstName-required');
    }
    else if (newUser.firstName.length < 1 || newUser.firstName.length > 19) {
        invalid.push('firstName-invalid');
    }
    if (newUser.lastName.length === 0 ) {
        invalid.push('lastName-required');
    }
    else if (newUser.lastName.length < 1 || newUser.lastName.length > 19) {
        invalid.push('lastName-invalid');
    }
    else if (newUser.middleName.length > 25) {
        invalid.push('middleName-invalid');
    }
    if (newUser.password.length === 0 ) {
        invalid.push('password-required');
    }
    else if (newUser.password.length < 8 || newUser.password.length > 20) {
        invalid.push('password-invalid');
    }
    if (newUser.confirmPassword.length === 0 ) {
        invalid.push('confirmPassword-required');
    }
    else if (newUser.confirmPassword.length < 8 || newUser.confirmPassword.length > 20) {
        invalid.push('confirmPassword-invalid');
    }
    if (newUser.userId.length === 0 ) {
        invalid.push('userID-required');
    }
    else if (newUser.userId.length < 5 || newUser.userId.length > 20) {
        invalid.push('userID-invalid');
    }
    if (newUser.cellPhone.length === 0 ) {
        invalid.push('cellPhone-required');
    }
    else if (newUser.cellPhone.length < 10) {
        invalid.push('cellPhone-invalid');
    }
    if (newUser.code.length === 0 ) {
        invalid.push('securityCode-required');
    }
    else if (newUser.code.length < 6 || newUser.code.length > 9) {
        invalid.push('securityCode-invalid');
    }
    if (newUser.privacyStatement === false ) {
        invalid.push('privacyStatement-required');
    }

    return invalid;
}
